import { ImageHelper } from '@/lib/helpers/image.helper'
import { ERankingType } from '@/types/auth'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { RANKING_IMAGES } from '../constants'

type Props = {
  type: ERankingType
  benefits: React.ReactNode[]
  border: string
  background: string
}

export const TierItem = ({ type, benefits, border, background }: Props) => {
  const t = useTranslations()
  const tickImages = {
    [ERankingType.NEW]: '/icons/coolclub/tick-blue.svg',
    [ERankingType.SILVER]: '/icons/coolclub/tick-silver.svg',
    [ERankingType.GOLD]: '/icons/coolclub/tick-golden.svg',
    [ERankingType.PLATINUM]: '/icons/coolclub/tick-platinum.svg',
  }

  return (
    <div className={`relative rounded-xl bg-gradient-to-r ${border} p-0.5`}>
      <div
        className={`relative overflow-hidden rounded-xl ${background} space-y-3 px-4 py-5`}
      >
        <Image
          src={ImageHelper.getImageUrl(t(RANKING_IMAGES[type]))}
          alt='Tier'
          width={100}
          height={36}
          className='h-9 w-auto object-cover'
        />

        <ul className='space-y-3'>
          {benefits.map((item, index) => (
            <li key={index + 1} className='flex items-center gap-4'>
              <Image src={tickImages[type]} alt='Tick' width={24} height={24} />
              <span className='font-sans text-sm leading-5 text-neutral-700'>
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
